import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";
import * as format from "../../common/FormatFunctions";

export class Clients extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      clientList: "",
      userSelected: false,
      selectedUser: "",
      selectedUserId: "",
      selectedUserLastUpdatedDateTime: "",
      selectedUserFirstName: "",
      selectedUserSurname: "",
      selectedUserAddressLine1: "",
      selectedUserAddressLine2: "",
      selectedUserPostcode: "",
      selectedUserTelephone: "",
      selectedUserEmail: "",
      selectedUserLabel: "",
      selectedUserLevel: [],
      selectedUserDisplayLevel: [],
      selectedUserNotes: "",
      userEdited: false,
      editedUserFirstName: "",
      editedUserSurname: "",
      editedUserAddressLine1: "",
      editedUserAddressLine2: "",
      editedUserPostcode: "",
      editedUserTelephone: "",
      editedUserEmail: "",
      editedUserLabel: "",
      editedUserLevel: [],
      editedUserNotes: "",
      userAdded: false,
      emailExists: false,
      deleteDialog: false,
    };
  }

  componentDidMount() {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }
    this.getClients();
  }

  async getClients() {
    this.setState({ loaded: false });

    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.roleType = 30;

    await api("userApiV1UserListByRoleType", userRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            clientList: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Clients could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListByRoleType has failed");
      }
    });

    this.setState({ loaded: true });
  }

  async getClientsActiveSets(selectedUserId) {
    this.setState({ clientSetsLoaded: false });

    let request = new Belfastpilatesappspotcom.SetRequest();
    request.codeTag = localStorage.getItem("globalBid");
    request.userId = selectedUserId;
    request.bookIdentifier = "BOOK";

    await api("setApiV1SetsGetByBookedUserId", request).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.setList)) {
          res.data.setList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let response = Belfastpilatesappspotcom.SetResponse.constructFromObject(
          res.data
        );
        console.log(response);

        if (response.errorCode === 0) {
          this.setState({
            clientSetsList: response.setList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "No Client Sets returned",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetsGetByBookedUserId has failed");
      }
    });

    this.setState({ clientSetsLoaded: true });
  }

  async getClientsVoucherCodes(selectedUserId) {
    this.setState({ clientVoucherCodesLoaded: false });

    let request = new Belfastpilatesappspotcom.VoucherRequest();
    request.codeTag = localStorage.getItem("globalBid");
    request.userId = selectedUserId;

    await api("voucherApiV1VoucherGetByUserId", request).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.voucherList)) {
          res.data.voucherList.forEach((e) => {
            delete e.dateCreated;
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.validFrom) {
              e.validFrom = e.validFrom.toJSON();
            }
            if (e.validTo) {
              e.validTo = e.validTo.toJSON();
            }
          });
        }

        let response =
          Belfastpilatesappspotcom.VoucherResponse.constructFromObject(
            res.data
          );
        console.log(response);

        if (response.errorCode === 0) {
          this.setState({
            clientVoucherList: response.voucherList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "No Vouchers Returned",
            life: 3000,
          });
        }
      } else {
        console.log("voucherApiV1VouchersGetByUserId has failed");
      }
    });

    this.setState({ clientVoucherCodesLoaded: true });
  }

  sendVoucherCodeToClient = async () => {
    let voucherRequest = new Belfastpilatesappspotcom.VoucherRequest();
    voucherRequest.codeTag = localStorage.getItem("globalBid");
    voucherRequest.userId = this.state.selectedUserId;

    await api("voucherApiV1VoucherCreateAndSendToClient", voucherRequest).then(
      (res) => {
        if (res.data) {
          let voucherResponse =
            Belfastpilatesappspotcom.VoucherResponse.constructFromObject(
              res.data
            );
          console.log(voucherResponse);

          if (voucherResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Voucher sent",
              life: 3000,
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Voucher could not be sent to client",
              life: 3000,
            });
          }
        } else {
          console.log("voucherApiV1VoucherCreateAndSendToClient has failed");
        }
      }
    );
  };
  updateClient = async () => {
    if (
      this.state.editedUserFirstName &&
      this.state.editedUserSurname &&
      Array.isArray(this.state.editedUserLevel)
    ) {
      let userRequest = new Belfastpilatesappspotcom.UserRequest();
      userRequest.codeTag = localStorage.getItem("globalBid");
      userRequest.id = this.state.selectedUserId;
      userRequest.lastUpdatedDateTime =
        this.state.selectedUserLastUpdatedDateTime;
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.contactTelephone = this.state.editedUserTelephone;
      userRequest.email = this.state.editedUserEmail;
      userRequest.label = this.state.editedUserLabel;
      userRequest.level = this.state.editedUserLevel;
      userRequest.notes = this.state.editedUserNotes;

      await api("userApiV1UserUpdateAccount", userRequest).then((res) => {
        if (res.data) {
          let userResponse =
            Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
          console.log(userResponse);

          if (userResponse.errorCode === 0) {
            this.setState({ userEdited: false }, () => {
              this.getClients();
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Client could not be updated, please try again",
              life: 3000,
            });
          }
        } else {
          console.log("userApiV1UserUpdateAccount has failed");
        }
      });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all required fields",
        life: 3000,
      });
    }
  };

  createClient = async () => {
    if (
      this.state.editedUserFirstName &&
      this.state.editedUserSurname &&
      Array.isArray(this.state.editedUserLevel)
    ) {
      let userRequest = new Belfastpilatesappspotcom.UserRequest();
      userRequest.codeTag = localStorage.getItem("globalBid");
      userRequest.roleType = 30;
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.contactTelephone = this.state.editedUserTelephone;
      userRequest.email = this.state.editedUserEmail;
      userRequest.label = this.state.editedUserLabel;
      userRequest.level = this.state.editedUserLevel;
      userRequest.notes = this.state.editedUserNotes;

      await api("userApiV1UserCreate", userRequest).then((res) => {
        if (res.data) {
          let userResponse =
            Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
          console.log(userResponse);

          if (userResponse.errorCode === 0) {
            this.setState({ userEdited: false, userAdded: false }, () => {
              this.getClients();
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Client could not be created, please try again",
              life: 3000,
            });
          }
        } else {
          console.log("userApiV1UserCreate has failed");
        }
      });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all required fields",
        life: 3000,
      });
    }
  };

  deleteClient = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.id = this.state.selectedUserId;
    userRequest.lastUpdatedDateTime =
      this.state.selectedUserLastUpdatedDateTime;

    await api("userApiV1UserDelete", userRequest).then((res) => {
      if (res.data) {
        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({ userEdited: false, userAdded: false }, () => {
            this.getClients();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Missing Fields",
            detail: "Client could not be deleted, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserDelete has failed");
      }
    });
  };

  displayClientActiveBookings = () => {
    // clientSetsLoaded
    if (!this.state.clientSetsLoaded) {
      return <label />;
    } else {
      return (
        <pr.DataTable
          value={this.state.clientSetsList}
          selectionMode="single"
          // selection={this.state.selectedUser}
          onSelectionChange={(e) => {
            console.log(e.data);
            // let displayLevelArray = [];
            // if (Array.isArray(e.data.level)) {
            //   e.data.level.forEach(f => {
            //     displayLevelArray.push(
            //       <span>
            //         {f}
            //         <br />
            //       </span>
            //     );
            //   });
            // }

            // this.setState(
            //   {
            //     userEdited: false,
            //     userSelected: true,
            //     selectedUser: e.data,
            //     selectedUserId: e.data.id,
            //     selectedUserLastUpdatedDateTime:
            //       e.data.lastUpdatedDateTime,
            //     selectedUserFirstName: e.data.firstName,
            //     selectedUserSurname: e.data.surname,
            //     selectedUserAddressLine1: e.data.addressLine1,
            //     selectedUserAddressLine2: e.data.addressLine2,
            //     selectedUserPostcode: e.data.postcode,
            //     selectedUserTelephone: e.data.contactTelephone,
            //     selectedUserEmail: e.data.email,
            //     selectedUserLabel: e.data.label,
            //     selectedUserLevel: e.data.level,
            //     selectedUserDisplayLevel: displayLevelArray,
            //     selectedUserNotes: e.data.notes
            //   },
            //   () => {
            //     console.log(this.state);
            //   }
            // );
          }}
          header="Users current list of active sets"
          autoLayout={true}
          paginator={false}
          alwaysShowPaginator={false}
          scrollable={true}
        >
          <pr.Column
            field="title"
            header="Title"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="instructorDetails"
            header="Instructors"
            body={(e) => {
              let nameArray = [];
              let i = 0;

              if (Array.isArray(e.instructorDetails)) {
                e.instructorDetails.forEach((f) => {
                  nameArray.push(
                    <span key={i}>
                      {(f.firstName || "") + " " + (f.surname || "")}
                      <br />
                    </span>
                  );
                  i++;
                });
              }

              return nameArray;
            }}
            sortable={false}
            filter={false}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="dayOfWeek"
            header="Day of the Week"
            body={(e) => {
              let daysToDisplay = [];
              let i = 0;

              if (Array.isArray(e.dayOfWeek)) {
                e.dayOfWeek.forEach((f) => {
                  let num = parseInt(f, 10);
                  if (num === 1) {
                    daysToDisplay.push(
                      <span key={i}>
                        Monday
                        <br />
                      </span>
                    );
                  } else if (num === 2) {
                    daysToDisplay.push(
                      <span key={i}>
                        Tuesday
                        <br />
                      </span>
                    );
                  } else if (num === 3) {
                    daysToDisplay.push(
                      <span key={i}>
                        Wednesday
                        <br />
                      </span>
                    );
                  } else if (num === 4) {
                    daysToDisplay.push(
                      <span key={i}>
                        Thursday
                        <br />
                      </span>
                    );
                  } else if (num === 5) {
                    daysToDisplay.push(
                      <span key={i}>
                        Friday
                        <br />
                      </span>
                    );
                  } else if (num === 6) {
                    daysToDisplay.push(
                      <span key={i}>
                        Saturday
                        <br />
                      </span>
                    );
                  } else if (num === 7) {
                    daysToDisplay.push(
                      <span key={i}>
                        Sunday
                        <br />
                      </span>
                    );
                  } else {
                  }

                  i++;
                });
              }

              return daysToDisplay;
            }}
            sortable={false}
            filter={false}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="level"
            header="Level"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field=""
            header="Start Time"
            body={(e) => {
              let timesToDisplay = [];
              let i = 0;

              if (Array.isArray(e.mondayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.mondayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.tuesdayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.tuesdayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.wednesdayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.wednesdayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.thursdayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.thursdayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.fridayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.fridayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.saturdayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.saturdayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              if (Array.isArray(e.sundayTime)) {
                timesToDisplay.push(
                  <span key={i}>
                    {e.sundayTime[0]}
                    <br />
                  </span>
                );
                i++;
              }

              return timesToDisplay;
            }}
            sortable={false}
            filter={false}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="startDateDisplayString"
            header="Start Date"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="endDateDisplayString"
            header="End Date"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field="bookList"
            header="Paid"
            body={(e) => {
              let nameArray = [];
              let i = 0;
              let paid = false;
              let paymentMethod = "";

              if (Array.isArray(e.bookList)) {
                e.bookList.forEach((f) => {
                  if (f.paid === true) {
                    paid = true;
                    paymentMethod = f.paymentMethod;
                  }
                  i++;
                });
              }
              if (paid) {
                return (
                  <div className="ui-g">
                    <div className="ui-g-12">
                      <label>Yes</label>
                    </div>
                    <div className="ui-g-12">
                      <label>{paymentMethod}</label>
                    </div>
                  </div>
                );
              } else {
                return <label>No</label>;
              }
            }}
            sortable={false}
            filter={false}
            style={{ overflow: "auto" }}
          />
        </pr.DataTable>
      );
    }
  };

  displayClientVoucherCodes = () => {
    if (!this.state.clientVoucherCodesLoaded) {
      return <label />;
    } else {
      return (
        <pr.DataTable
          value={this.state.clientVoucherList}
          selectionMode="single"
          // selection={this.state.selectedUser}
          onSelectionChange={(e) => {
            console.log(e.data);
          }}
          header="Voucher Codes"
          autoLayout={true}
          paginator={false}
          alwaysShowPaginator={false}
          scrollable={true}
        >
          <pr.Column
            field="voucherName"
            header="Voucher Name"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
          />
          <pr.Column
            field=""
            header="Valid From"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
            body={(e) => {
              let value = "";
              if (format.isNotNull(e.validFrom)) {
                value = format.formatDate(e.validFrom, "DDMMYY");
              }
              return value;
            }}
          />
          <pr.Column
            field=""
            header="Valid To"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
            body={(e) => {
              let value = "";
              if (format.isNotNull(e.validTo)) {
                value = format.formatDate(e.validTo, "DDMMYY");
              }
              return value;
            }}
          />
          <pr.Column
            field="useCount"
            header="Used"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
            body={(e) => {
              let used = "No";
              if (format.isNotNull(e.useCount)) {
                if (e.useCount == 1) {
                  used = "Yes";
                }
              }

              return used;
            }}
          />
          <pr.Column
            field="valueOff"
            header="Value Off"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
            body={(e) => {
              let valueOff = 0;

              if (format.isNotNull(e.valueOff)) {
                valueOff = e.valueOff;
              }
              return "£" + valueOff;
            }}
          />
          <pr.Column
            field="totalDiscount"
            header="Amount Paid After Discount"
            sortable={true}
            filter={true}
            style={{ overflow: "auto" }}
            body={(e) => {
              let value = 0;

              if (format.isNotNull(e.totalDiscount)) {
                value = format.formatValue(e.totalDiscount / 100);
              }
              return "£" + value;
            }}
          />
        </pr.DataTable>
      );
    }
  };

  render() {
    const levelOptions = [
      { label: "Consultation", value: "Consultation" },
      { label: "Beginner/Progressive", value: "Beginner/Progressive" },
      { label: "Progressive/Intermediate", value: "Progressive/Intermediate" },
      { label: "Intermediate/Advanced", value: "Intermediate/Advanced" },
      { label: "Reformer", value: "Reformer" },
      { label: "Mum and Baby", value: "Mum and Baby" },
      { label: "Antenatal", value: "Antenatal" },
      { label: "Kids", value: "Kids" },
      { label: "Mature Movers", value: "Mature Movers" },
    ];

    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl
          style={{ textAlign: "left" }}
          ref={(el) => (this.growl = el)}
        />
        <pr.Dialog
          header="Delete Client"
          footer={
            <div>
              <pr.Button
                label="Yes"
                onClick={() => {
                  this.setState(
                    { deleteDialog: false, userEdited: false },
                    () => {
                      this.deleteClient();
                    }
                  );
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                label="No"
                onClick={() => {
                  this.setState({ deleteDialog: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          }
          visible={this.state.deleteDialog}
          style={{ width: "50vw" }}
          modal={true}
          onHide={(e) => this.setState({ deleteDialog: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        <div className="ui-g-12">
          <div className="card">
            <div className="ui-g">
              <div className="ui-g-12 ui-md-4">
                <pr.DataTable
                  value={this.state.clientList}
                  selectionMode="single"
                  selection={this.state.selectedUser}
                  onSelectionChange={(e) => {
                    let displayLevelArray = [];
                    if (Array.isArray(e.data.level)) {
                      e.data.level.forEach((f) => {
                        displayLevelArray.push(
                          <span>
                            {f}
                            <br />
                          </span>
                        );
                      });
                    }

                    this.getClientsActiveSets(e.data.id);
                    this.getClientsVoucherCodes(e.data.id);

                    this.setState(
                      {
                        userEdited: false,
                        userSelected: true,
                        selectedUser: e.data,
                        selectedUserId: e.data.id,
                        selectedUserLastUpdatedDateTime:
                          e.data.lastUpdatedDateTime,
                        selectedUserFirstName: e.data.firstName,
                        selectedUserSurname: e.data.surname,
                        selectedUserAddressLine1: e.data.addressLine1,
                        selectedUserAddressLine2: e.data.addressLine2,
                        selectedUserPostcode: e.data.postcode,
                        selectedUserTelephone: e.data.contactTelephone,
                        selectedUserEmail: e.data.email,
                        selectedUserLabel: e.data.label,
                        selectedUserLevel: e.data.level,
                        selectedUserDisplayLevel: displayLevelArray,
                        selectedUserNotes: e.data.notes,
                        clientSetsList: [],
                        clientVoucherList: [],
                      },
                      () => {
                        console.log(this.state);
                      }
                    );
                  }}
                  header="Select a Client"
                  autoLayout={true}
                  paginator={false}
                  alwaysShowPaginator={false}
                  scrollable={true}
                >
                  <pr.Column
                    field="firstName"
                    header="First Name"
                    sortable={true}
                    filter={true}
                    style={{ overflow: "auto" }}
                  />
                  <pr.Column
                    field="surname"
                    header="Surname"
                    sortable={true}
                    filter={true}
                    style={{ overflow: "auto" }}
                  />
                  <pr.Column
                    field="level"
                    header="Level"
                    body={(e) => {
                      let levelArray = [];

                      if (Array.isArray(e.level)) {
                        e.level.forEach((f) => {
                          levelArray.push(f + "\n");
                        });
                      }

                      return levelArray;
                    }}
                    sortable={true}
                    filter={true}
                    style={{ overflow: "auto" }}
                  />
                  <pr.Column
                    field="email"
                    header="Email"
                    sortable={true}
                    filter={true}
                    style={{ overflow: "auto" }}
                  />
                </pr.DataTable>
                {localStorage.getItem("roleType") !== "10" ? (
                  <pr.Button
                    label=" "
                    onClick={() => {}}
                    style={{ width: "100%" }}
                  />
                ) : (
                  <pr.Button
                    label="Add New"
                    onClick={() => {
                      this.setState({
                        userSelected: false,
                        userEdited: true,
                        userAdded: true,
                        editedUserFirstName: "",
                        editedUserSurname: "",
                        editedUserAddressLine1: "",
                        editedUserAddressLine2: "",
                        editedUserPostcode: "",
                        editedUserTelephone: "",
                        editedUserEmail: "",
                        editedUserLabel: "",
                        editedUserLevel: [],
                        editedUserNotes: "",
                        clientSetsList: [],
                        clientVoucherList: [],
                      });
                    }}
                    style={{ width: "100%" }}
                  />
                )}
              </div>

              {!this.state.userEdited ? (
                <label />
              ) : (
                <div className="ui-g-12 ui-md-8">
                  <div className="ui-g-12">
                    <pr.Button
                      className="secondary-btn"
                      icon="pi pi-times"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: true,
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>
                  <div className="ui-g-12 ui-md-6">
                    <div className="ui-g-12">
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserFirstName === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserFirstName}
                          onChange={(e) =>
                            this.setState({
                              editedUserFirstName: e.target.value,
                            })
                          }
                        />
                        <label>First Name*</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserAddressLine1 === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserAddressLine1}
                          onChange={(e) =>
                            this.setState({
                              editedUserAddressLine1: e.target.value,
                            })
                          }
                        />
                        <label>Address Line 1</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserPostcode === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserPostcode}
                          onChange={(e) =>
                            this.setState({
                              editedUserPostcode: e.target.value,
                            })
                          }
                        />
                        <label>Postcode</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserEmail === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserEmail}
                          onChange={(e) => {
                            this.state.clientList.some((f) => {
                              if (e.target.value === f.email) {
                                this.setState({
                                  emailExists: true,
                                });
                                return true;
                              } else {
                                this.setState({
                                  emailExists: false,
                                });
                                return false;
                              }
                            });
                            this.setState({
                              editedUserEmail: e.target.value,
                            });
                          }}
                        />
                        <label>Email</label>
                      </span>
                      {!this.state.emailExists ? (
                        <label />
                      ) : (
                        <label style={{ color: "red" }}>
                          Email already exists
                        </label>
                      )}
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserLabel === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserLabel}
                          onChange={(e) =>
                            this.setState({
                              editedUserLabel: e.target.value,
                            })
                          }
                        />
                        <label>Label</label>
                      </span>
                    </div>
                  </div>
                  <div className="ui-g-12 ui-md-6">
                    <div className="ui-g-12">
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserSurname === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserSurname}
                          onChange={(e) =>
                            this.setState({
                              editedUserSurname: e.target.value,
                            })
                          }
                        />
                        <label>Surname*</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserAddressLine2 === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserAddressLine2}
                          onChange={(e) =>
                            this.setState({
                              editedUserAddressLine2: e.target.value,
                            })
                          }
                        />
                        <label>Address Line 2</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                      <span className="md-inputfield form-field">
                        <input
                          className={
                            this.state.editedUserTelephone === ""
                              ? "ui-inputtext"
                              : "ui-inputtext ui-state-filled"
                          }
                          type="text"
                          value={this.state.editedUserTelephone}
                          onChange={(e) =>
                            this.setState({
                              editedUserTelephone: e.target.value,
                            })
                          }
                        />
                        <label>Telephone</label>
                      </span>
                    </div>
                    <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                      <label>Level*: </label>
                      <pr.MultiSelect
                        value={this.state.editedUserLevel || []}
                        options={levelOptions}
                        onChange={(e) => {
                          console.log(e.value);
                          this.setState({ editedUserLevel: e.value });
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <label>Notes:</label>
                    <br />
                    <textarea
                      rows="10"
                      readOnly={false}
                      value={this.state.editedUserNotes}
                      onChange={(e) =>
                        this.setState({
                          editedUserNotes: e.target.value,
                        })
                      }
                      style={{ width: "100%", resize: "none" }}
                    />
                  </div>
                  <div className="ui-g-12">
                    <pr.Button
                      label="Save"
                      disabled={this.state.emailExists}
                      onClick={() => {
                        this.state.userAdded
                          ? this.createClient()
                          : this.updateClient();
                      }}
                      style={{ float: "right" }}
                    />
                    {this.state.userAdded ||
                    localStorage.getItem("roleType") !== "10" ? (
                      <label />
                    ) : (
                      <pr.Button
                        label="Delete"
                        onClick={() => {
                          this.setState({ deleteDialog: true });
                        }}
                        style={{ float: "right" }}
                      />
                    )}
                    <pr.Button
                      label="Cancel"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: true,
                        });
                      }}
                      style={{ float: "right" }}
                    />
                    <pr.Button
                      label="Send Voucher"
                      onClick={() => {
                        this.sendVoucherCodeToClient();
                      }}
                      style={{ float: "right" }}
                    />
                  </div>
                </div>
              )}

              {!this.state.userSelected ? (
                <label />
              ) : (
                <div className="ui-g-12 ui-md-8">
                  <div className="ui-g-12">
                    <pr.Button
                      className="secondary-btn"
                      icon="pi pi-pencil"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userSelected: false,
                          userEdited: true,
                          editedUserFirstName: this.state.selectedUserFirstName,
                          editedUserSurname: this.state.selectedUserSurname,
                          editedUserAddressLine1:
                            this.state.selectedUserAddressLine1,
                          editedUserAddressLine2:
                            this.state.selectedUserAddressLine2,
                          editedUserPostcode: this.state.selectedUserPostcode,
                          editedUserTelephone: this.state.selectedUserTelephone,
                          editedUserEmail: this.state.selectedUserEmail,
                          editedUserLabel: this.state.selectedUserLabel,
                          editedUserLevel: this.state.selectedUserLevel,
                          editedUserNotes: this.state.selectedUserNotes,
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>
                  <div className="ui-g-12 ui-md-6">
                    <div className="ui-g-12">
                      <b>First Name: </b>
                      <label>{this.state.selectedUserFirstName || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Address Line 1: </b>
                      <label>{this.state.selectedUserAddressLine1 || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Postcode: </b>
                      <label>{this.state.selectedUserPostcode || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Email: </b>
                      <label>{this.state.selectedUserEmail || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Label: </b>
                      <label>{this.state.selectedUserLabel || ""}</label>
                    </div>
                  </div>
                  <div className="ui-g-12 ui-md-6">
                    <div className="ui-g-12">
                      <b>Surname: </b>
                      <label>{this.state.selectedUserSurname || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Address Line 2: </b>
                      <label>{this.state.selectedUserAddressLine2 || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Telephone: </b>
                      <label>{this.state.selectedUserTelephone || ""}</label>
                    </div>
                    <div className="ui-g-12">
                      <b>Level: </b>
                      <label>{this.state.selectedUserDisplayLevel || ""}</label>
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <b>Notes:</b>
                    <br />
                    <textarea
                      rows="10"
                      readOnly={true}
                      value={this.state.selectedUserNotes || ""}
                      style={{ width: "100%", resize: "none" }}
                    />
                  </div>
                  <div className="ui-g-12">
                    {this.displayClientActiveBookings()}
                  </div>
                  <div className="ui-g-12">
                    {this.displayClientVoucherCodes()}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/Clients.js